<template>
  <main class="container">
    <h1
      class="page-title"
      :class="{ 'has-discount': hasBroadbandDiscount }"
      data-testid="product-title"
    >
      {{ product.title }}
    </h1>

    <discount-infobox
      v-if="hasBroadbandDiscount"
      :text="discount.description"
    />

    <div class="wrap">
      <BackButton class="back-link" />

      <form class="form">
        <fieldset class="form__fieldset default-product">
          <Product
            :option="defaultBroadbandProductOption"
            :defaultOption="defaultBroadbandProductOption"
            :selected="isDefaultBroadbandProductOptionSelected"
            @option-selected="updateSelectedOption"
          />
        </fieldset>

        <h1
          v-if="upgradeBroadbandProductOptions.length > 0"
          class="upgrade-text"
        >
          Upgrade?
        </h1>

        <fieldset class="form__fieldset upgrade-products">
          <div class="upgrade-products__wrapper">
            <Product
              v-for="option in upgradeBroadbandProductOptions"
              :key="option.code"
              :option="option"
              :defaultOption="defaultBroadbandProductOption"
              :selected="selectedBroadbandProductOption.code === option.code"
              @option-selected="updateSelectedOption"
            />
          </div>
        </fieldset>
      </form>

      <button
        class="btn btn--big next-btn"
        data-testid="package-builder-next"
        @click="trackSubmitBtn"
      >
        Next
      </button>
    </div>
  </main>
</template>

<script>
import Product from "@/components/Product";
import { mapGetters, mapMutations, mapState } from "vuex";
import DiscountInfobox from "@/components/DiscountInfobox";

export default {
  name: "BroadbandUpgradePicker",
  computed: {
    ...mapState(["discount", "products"]),
    ...mapGetters({
      isDefaultBroadbandProductOptionSelected:
        "isDefaultBroadbandProductOptionSelected",
      defaultBroadbandProductOption: "defaultBroadbandProductOption",
      upgradeBroadbandProductOptions: "upgradeBroadbandProductOptions",
      selectedBroadbandProductOption: "selectedBroadbandProductOption",
      hadValidDiscount: "hasValidDiscount",
    }),
    product() {
      return this.products.find((product) => product.type === "Broadband");
    },
    hasBroadbandDiscount() {
      return (
        this.hadValidDiscount &&
        this.discount.productType === "Broadband" &&
        this.product.options.some(
          (option) => option.code === this.discount.productCode,
        )
      );
    },
  },
  methods: {
    ...mapMutations({
      setProductOption: "SET_PRODUCT_OPTION",
      showBackBtn: "SHOW_BACK_BTN",
    }),
    trackSubmitBtn() {
      this.trackGoogleEvent(
        `Click Next on Broadband Selection`,
        "Get Price",
        "Select Broadband",
      );

      this.$router.push("short-summary");
    },
    updateSelectedOption(code) {
      this.setProductOption({
        type: "Broadband",
        code,
      });
    },
  },
  created() {
    this.showBackBtn();
  },
  components: {
    DiscountInfobox,
    Product,
  },
};
</script>

<style lang="scss" scoped>
.container {
  @include media("<medium") {
    width: 90vw;
    padding: 0;
  }

  @include media(">=medium") {
    max-width: 90vw;
    display: flex;
    flex-direction: column;
  }
}

.page-title {
  &.has-discount {
    margin-bottom: 0.2rem;
  }
}

.discount-info {
  font-size: 18px;
  text-align: center;
  font-weight: $font-regular;
  margin-bottom: 2rem;

  span {
    white-space: pre-wrap;
  }
}

.wrap {
  margin: 0 auto;

  .default-product {
    margin-bottom: 0;

    @include media("<medium") {
      .product-option {
        margin: 0;
      }
    }

    .product-option {
      margin-bottom: 0;
    }
  }

  .upgrade-text {
    color: $brand-dark-blue;
  }

  .upgrade-products__wrapper {
    display: flex;
    flex-direction: column;
    gap: 0 1rem;

    @include media("<medium") {
      flex-direction: column;
    }
  }

  .next-btn {
    align-self: center;
    margin-bottom: 0;

    @include media(">=medium") {
      width: 45rem;
    }
  }
}
</style>
